import { useState } from "react";
import { TabOption } from "../components/Tabs/Tabs";

export const useTabsLogic = (tabOptions: TabOption[]) => {
  const [activeTab, setActiveTab] = useState(tabOptions[0]?.value ?? "");

  const handleChangeActiveTab = (tabValue: string) => {
    setActiveTab(tabValue);
  };

  return {
    activeTab,
    handleChangeActiveTab,
  };
};
